import PropTypes from 'prop-types'
import React, {Component} from 'react'
import {Responsive, Segment, Visibility} from "semantic-ui-react";
import HomepageHeading from "../HomepageHeading";
import DesktopMenu from "./DesktopMenu";

class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({fixed: false});
  showFixedMenu = () => this.setState({fixed: true});

  render() {
    const {children} = this.props;

    return (
      <Responsive minWidth={768}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            inverted
            textAlign='center'
            style={{minHeight: '-webkit-fill-available', padding: '1em 0em'}}
            vertical
          >
            <DesktopMenu fixed={this.state.fixed}/>

            <HomepageHeading mobile={false}/>
          </Segment>
        </Visibility>

        {children}
      </Responsive>
    )
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

export default DesktopContainer



// WEBPACK FOOTER //
// ./src/components/desktop/DesktopContainer.js